import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../hooks/useAppSelector';
import { getDashboardPath } from '../utils/getDashboardPath';

/**
 * When user is already logged in and visits "/" or "/login", redirect to their dashboard.
 * Shows loading while auth is being checked.
 */
const AuthRedirectWrapper = ({ children }) => {
  const { user, isAuthenticated, loading } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const pathname = location.pathname || '';
  const isHomeOrLogin = pathname === '/' || pathname === '/login';

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4" />
          <p className="text-white/70">Loading...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated && user && isHomeOrLogin) {
    const dashboardPath = getDashboardPath(user);
    return <Navigate to={dashboardPath} replace />;
  }

  return children;
};

export default AuthRedirectWrapper;
